import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../Button';

import './style.scss';

export interface WebformAssessmentActionsInnerProps {
  prevButtonLabel?: string;
  isPrevButtonDisabled?: boolean;
  nextButtonLabel?: string;
  isNextButtonDisabled?: boolean;
  showSubmitButton?: boolean;
  submitButtonLabel?: string;
  isSubmitting?: boolean;
  onPreviousPage: () => void;
  onNextPage: () => void;
}

const WebformAssessmentActionsInner: React.FC<WebformAssessmentActionsInnerProps> = (props) => {
  const {
    prevButtonLabel,
    isPrevButtonDisabled = false,
    nextButtonLabel,
    isNextButtonDisabled = false,
    showSubmitButton = false,
    submitButtonLabel,
    isSubmitting = false,
    onPreviousPage,
    onNextPage,
  } = props;

  const { t } = useTranslation();

  const submitLabel = isSubmitting
    ? t('webform.actions.submitting_label', 'Versturen...')
    : (submitButtonLabel || t('webform.actions.submit_label'));

  return (
    <div className="WebformAssessment__Actions">
      <Button
        type="transparent"
        disabled={isPrevButtonDisabled || isSubmitting}
        onClick={onPreviousPage}
      >
        <i className="icon icon-chevron-right icon-orientation-left" />
        {prevButtonLabel || t('webform.actions.prev_label')}
      </Button>

      <Button
        type="primary"
        disabled={isNextButtonDisabled || isSubmitting}
        onClick={onNextPage}
      >
        {showSubmitButton ? submitLabel : (nextButtonLabel || t('webform.actions.next_label'))}
        <i className="icon icon-arrow-right" />
      </Button>
    </div>
  );
};

export default WebformAssessmentActionsInner;
